export default {
  primaryKonekto: '#0076bb',
  primaryKonekto10: 'rgba(0, 118, 187, 0.1)',
}
